"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonUtils_1 = require("../../../Helpers/commonUtils");
const youtubeProvider_1 = require("./youtubeProvider");
const youkuProvider_1 = require("./youkuProvider");
const qqProvider_1 = require("./qqProvider");
const createUrlParser = (initialPlugins = {}) => {
    let plugins = Object.assign({}, initialPlugins);
    const parseProvider = (url) => {
        const match = url.match(/(?:(?:https?:)?\/\/)?(?:[^\.]+\.)?(\w+)\./i);
        return match ? match[1] : undefined;
    };
    const removeEmptyParameters = (result) => {
        if (result.params && Object.keys(result.params).length === 0) {
            delete result.params;
        }
        return result;
    };
    const parse = (url) => {
        const provider = parseProvider(url);
        const plugin = provider && plugins[provider];
        if (!provider || !plugin || !plugin.parse) {
            return undefined;
        }
        const result = plugin.parse(url, (0, commonUtils_1.getQueryParams)(url));
        if (result) {
            const cleanedResult = removeEmptyParameters(result);
            cleanedResult.provider = plugin.provider;
            return cleanedResult;
        }
        return undefined;
    };
    const bind = (plugin) => {
        plugins[plugin.provider || ''] = plugin;
        if (plugin.alternatives) {
            plugin.alternatives.forEach(alternative => {
                plugins[alternative] = plugin;
            });
        }
    };
    bind(youtubeProvider_1.default);
    bind(youkuProvider_1.default);
    bind(qqProvider_1.default);
    const create = (op) => {
        var _a;
        const vi = op.videoInfo;
        let params = op.params;
        const plugin = plugins[vi.provider];
        params = params === 'internal' ? vi.params : params || {};
        if (plugin) {
            op.format = (op.format || plugin.defaultFormat);
            if ((_a = plugin.formats) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(op.format)) {
                return plugin.formats[op.format](vi, (0, commonUtils_1.cloneObject)(params));
            }
        }
        return undefined;
    };
    return {
        plugins,
        parseProvider,
        removeEmptyParameters,
        parse,
        bind,
        create,
    };
};
exports.default = createUrlParser;
